"use strict";

EWS.Ready((EWS) => {
    if (!IsImpersonateUser) {
        EWS.Command.AddMenu("ReportEditMenu", (control, name, menu, callback) => {
            menu.innerHTML = "";
            callback(control, menu);
        }, (control, name, menu, menuArgs) => {
            menu.style.display = "none";
            menu.innerHTML = "";

            const ReportEditMenu = new ECP.EC_Request("SavedReport_ReportEditMenu");
            ReportEditMenu.AddRequestVariable("ReportID", menuArgs.report);
            ReportEditMenu.Submit().then((result) => {
                if (result.report.length > 1) {
                    let html = "";

                    for (let i = 0; i < result.report.length; i++) {
                        html += `<div class=ews-menu-item url="${result.report[i].url}">`
                            + ` <div class="ews-menu-icon ews-icon-${result.report[i].icon}"></div>`
                            + ` <div class=ews-menu-label>${result.report[i].name}</div>`
                            + "</div>";
                    }
                    menu.innerHTML = html;
                    menu.style.display = "block";
                    menu = EC_Fmt.RemoveAllEventListeners(menu);
                    menu.addEventListener("click", () => {
                        const item = event.target.closest(".ews-menu-item");

                        if (item && menu.contains(item)) {
                            window.location.href = item.getAttribute("url");
                        }
                    });
                } else if (result.report.length === 1) {
                    EWS.ShowLoading();
                    window.location.href = result.report[0].url;
                } else if (result.type === "Spreadsheet") {
                    ECP.Dialog.Alert("This Spreadsheet contains no linked reports.");
                } else {
                    EWS.ShowLoading();
                    window.location.href = `Home?DashboardID=${ECP.CommonDashboards.ReportEdit}&ParseFromReportURL=True&ReportID=${menuArgs.report}`;
                }
            });
        });
    }

    EWS.Command.AddMenu("SwitchGraphMenu", (control, name, menu, callback) => {
        menu.innerHTML = `<div class=ews-menu-item command="Area Graph">`
            + `<div class="ews-menu-icon ews-icon-areagraph"></div>`
            + `<div class=ews-menu-label>`
            + `Area Graph`
            + `</div>`
            + `</div>`

            + `<div class=ews-menu-item command="Bar Graph">`
            + `<div class="ews-menu-icon ews-icon-bargraph"></div>`
            + `<div class=ews-menu-label> `
            + `Bar Graph`
            + `</div>`
            + `</div>`

            + `<div class=ews-menu-item command="Column Graph">`
            + `<div class="ews-menu-icon ews-icon-columngraph"></div>`
            + `<div class=ews-menu-label>`
            + `Column Graph`
            + `</div>`
            + `</div>`

            + `<div class=ews-menu-item command="Line Graph">`
            + `<div class="ews-menu-icon ews-icon-report"></div>`
            + `<div class=ews-menu-label>`
            + `Line Graph`
            + `</div>`
            + `</div>`

            + `<div class=ews-menu-item command="Pie Chart">`
            + `<div class="ews-menu-icon ews-icon-graph"></div>`
            + `<div class=ews-menu-label>`
            + `Pie Chart`
            + `</div>`
            + `</div>`

            + `<div class=ews-menu-item command="Doughnut Chart">`
            + `<div class="ews-menu-icon ews-icon-doughnut"></div>`
            + `<div class=ews-menu-label>`
            + `Doughnut Chart`
            + `</div>`
            + `</div>`;

        callback(control, menu);
    }, (control, name, menu, arg) => {
        menu = EC_Fmt.RemoveAllEventListeners(menu);

        menu.addEventListener("click", (event) => {
            const item = event.target.closest(".ews-menu-item");

            if (item && menu.contains(item)) {
                EWS.Command.HideAllMenus();

                arg.switchGraph(item.getAttribute("command"));
            }
        });
    });

    const ChartDataIcon = document.querySelector(".ChartData .ews-icon-graph");
    if (ChartDataIcon) {
        ChartDataIcon.addEventListener("click", (event) => {
            const target = event.target;

            EWS.Command.ShowMenu("SwitchGraphMenu", target, {
                switchGraph(graph) {
                    const reportUrl = document.getElementById("ReportUrl").value;
                    const queries = reportUrl.split("&").map((query) => {
                        if (query.split("=")[0] === "Parameters") {
                            const parameters = query;
                            const parametersValue = parameters.split("=")[1];
                            let parameterArray = parametersValue.split("%7c");
                            // Task 760106: Comparison Sales Report: Change the Report type with report icon in upper right cornerdoes not change Report Type
                            if (parameterArray.indexOf("E|F")) {
                                parameterArray = parametersValue.split("|");
                            }
                            parameterArray = parameterArray.map((parameter) => {
                                if (parameter.split("%7e")[0] === "F%3aDisplay") {
                                    return `F%3aDisplay%7eV%3a${encodeURIComponent(graph)}`;
                                } if (parameter.split("~")[0] === "F:Display") {
                                    return `F:Display~V:${encodeURIComponent(graph)}`;
                                }
                                return parameter;
                            });

                            return `Parameters=${parameterArray.join("%7c")}`;
                        }
                        return query;
                    });

                    ECP.Dialog.ShowLoading();

                    window.location.href = `Home?DashboardID=${ECP.CommonDashboards.ReportView}&${queries.join("&")}`;
                }
            });
        });
    }

    const updateTime = document.getElementById("NextUpdateTime");
    if (updateTime) {
        DataConnection(updateTime.getAttribute("enddatetime"), updateTime.getAttribute("startdatetime"));
    }

    const reportURL = document.getElementById("ReportUrl");
    if (reportURL?.value && window.location.search.includes(`DashboardID=${ECP.CommonDashboards.ReportView}`) && (`${window.location.pathname}?${reportURL.value}`).length < 2000) {
        EC_Fmt.ReplaceState(window.history.state, "", `Home?DashboardID=${ECP.CommonDashboards.ReportView}&${reportURL.value}`);
    }
});

// eslint-disable-next-line no-unused-vars
function convertToFusion() {
    ECP.Dialog.ShowLoading();

    const myRequest = new ECP.EC_Request("Convert_Sales_To_Fusion");
    const ParseFromReportURL = EC_Fmt.GetPageParameter("ParseFromReportURL");
    const ReportID = EC_Fmt.GetPageParameter("ReportID");
    if (ParseFromReportURL?.toLowerCase() === "true" && EC_Fmt.Null2ZeroInt(ReportID) > 0) {
        myRequest.AddRequestVariable("ReportID", ReportID, ECP.EC_Verb.Post);
    } else {
        myRequest.AddRequestVariable("ReportURL", EC_Fmt.Get_QueryString("ReportID"), ECP.EC_Verb.Post);
    }
    myRequest.Submit().then((result) => {
        if (EC_Fmt.Null2ZeroInt(result.FusionReportID) > 0) {
            window.location.href = `Home?DashboardID=${ECP.CommonDashboards.FusionView}&ReportID=${result.FusionReportID}`;
        }
        ECP.Dialog.HideLoading();
    }).catch((e) => {
        ECP.Dialog.HideLoading();
        throw e;
    });
}

// eslint-disable-next-line no-unused-vars
function EditReportMenu(trigger, report) {
    if (EWS?.Command) {
        EWS.Command.ShowMenu("ReportEditMenu", trigger, {
            report
        });
    }
}

// eslint-disable-next-line no-unused-vars
function LeaveImporsonate(url) {
    if (EWS) {
        const html = "<table style=width:100%;height:100% class=NoPadding>"
            + "<tr>"
            + "<td style=text-align:center;font-size:16px>You are impersonating a user.<br>Do you want to leave and go back to your login?</td>"
            + "</tr>"
            + "</table>";

        const dialogConfirm = ECP.Dialog.ShowDialog("Confirm", html, {
            cancelButtonTitle: "Cancel",
            confirmButtonAction(Dialog) {
                ECP.Dialog.CloseDialog(Dialog);
                // Task 667450: ReportView dashboard View through QuickLink, button displays prompt information questions.
                if (IsImpersonateUser) {
                    // Task 707408: click Edit and SaveReport is pop cinfirm message(The previous Url was really ReportView, now it has always been Quick?QuickKey=(Task 682571))
                    const OldUrl = url;
                    const NewUrl = OldUrl.replace(/QuickKey=(.+?)&/, "");
                    window.location.href = `Home?DashboardID=${ECP.CommonDashboards.LogOn}&DestURL=${encodeURIComponent(NewUrl)}`;
                } else {
                    window.location.href = url;
                }
            }
        });

        dialogConfirm.firstChild.style.height = "200px";
    }
}

// eslint-disable-next-line no-unused-vars
function LeaveGuest() {
    if (EWS) {
        const html = "<table style=width:100%;height:100% class=NoPadding>"
            + "<tr>"
            + "<td style=text-align:center;font-size:16px>You are currently a guest.<br>Do you want to log in?</td>"
            + "</tr>"
            + "</table>";

        const dialogConfirm = ECP.Dialog.ShowDialog("Confirm", html, {
            cancelButtonTitle: "Cancel",
            confirmButtonAction(Dialog) {
                ECP.Dialog.CloseDialog(Dialog);

                window.location.href = "Home";
            }
        });

        dialogConfirm.firstChild.style.height = "200px";
    }
}

// eslint-disable-next-line no-unused-vars
function SaveAndViewFormatted(id, url, documentID) {
    if (EWS?.SavedReport) {
        if (id > 0) {
            EWS.SavedReport.Save(url, id, null, () => {
                EWS.ShowLoading();
                // Task 644849: click 'Click here to Save Changes' does not display data with format added
                window.location.href = `${url}&DocumentID=${documentID}`;
            });
        } else {
            EWS.SavedReport.SaveAs(url, null, null, () => {
                EWS.ShowLoading();
                window.location.href = `${url}&DocumentID=${documentID}`;
            });
        }
    }
}

// eslint-disable-next-line no-unused-vars
function RefreshReport(LastDate, DocumentID) {
    EWS.ShowLoading();

    const ReportURL = document.getElementById("ReportUrl");
    if (ReportURL?.value !== "") {
        if (DocumentID > 0) {
            window.location = `Home?DashboardID=${ECP.CommonDashboards.ReportView}&MinCacheTime=${LastDate}&${ReportURL.value}&Regenerate=True&DocumentID=${DocumentID}&`;
        } else {
            window.location = `Home?DashboardID=${ECP.CommonDashboards.ReportView}&MinCacheTime=${LastDate}&${ReportURL.value}`;
        }
    } else {
        ECP.Dialog.Alert("This report is loading. Please wait until the report is finished.");
    }
}

// eslint-disable-next-line no-unused-vars
function CreateReport(form) {
    if (typeof form === "string") {
        form = document.querySelector(form);
    }

    EWS.ShowLoading();
    form.submit();
}

// eslint-disable-next-line no-unused-vars
function InvoicePaymentReport(form) {
    form = document.getElementById("ReportFilter");

    if (form) {
        const paymentInvoiceID = form.querySelector("#PaymentInvoiceIDInput").value;
        const StartDate = form.querySelector("#StartDate").value;
        const EndDate = form.querySelector("#EndDate").value;

        if (StartDate !== "" && EndDate === "" && paymentInvoiceID === "") {
            ECP.Dialog.Alert("End Date is required to create report.");
        } else if (EndDate !== "" && StartDate === "" && paymentInvoiceID === "") {
            ECP.Dialog.Alert("Start Date is required to create report.");
        } else if (paymentInvoiceID === "" && StartDate === "" && EndDate === "") {
            ECP.Dialog.Alert("Start and End Date or Payment Invoice must be selected to create report.");
        } else {
            EWS.ShowLoading();
            form.submit();
        }
    }
}

function DataConnection(endDateTime, startDateTime) {
    const NextUpdateTime = document.getElementById("NextUpdateTime");
    const displayCountdown = (minutes, seconds) => {
        if (minutes === 0 && seconds === 0) {
            NextUpdateTime.innerHTML = "0:00";
        } else {
            NextUpdateTime.innerHTML = `${minutes}:${EC_Fmt.Right(`0${seconds}`, 2)}`;
        }
    };
    CountdownInterval(endDateTime, startDateTime, 1000, displayCountdown);
}

// Task 1006136: FluxEdit.js code clean up
function CountdownInterval(endDateTime, startDateTime, milliseconds, callback) {
    let interval = null;
    startDateTime = EC_Fmt.DateTimeParseFormat(startDateTime);
    endDateTime = EC_Fmt.DateTimeParseFormat(endDateTime);

    if (new Date(endDateTime) > new Date(startDateTime)) {
        let timeDiff = new Date(endDateTime) - new Date(startDateTime);

        interval = setInterval(() => {
            timeDiff -= milliseconds;

            if (timeDiff > 0) {
                const minutes = parseInt((timeDiff / 1000 / 60) % 60, 10);
                const seconds = parseInt((timeDiff / 1000) % 60, 10);

                if (callback) {
                    callback(minutes, seconds);
                }
            } else {
                clearInterval(interval);
            }
        }, milliseconds);
    }

    return interval;
}
